<template>
<div id="room_alerts" v-if="noacc.state != 'off'">
  <div class="alerts_card">
   <b-row v-if="noacc.show_back">
     <b-col style="text-align:center">
        <b-button size="sm" variant="primary"
          @click="app.goBack()">
           Click to go back
        </b-button>
     </b-col>
   </b-row>
   <b-row>
     <b-col style="position:relative;text-align:center">
        <img v-if="noacc.rlogo.sh && noacc.rlogo.en"
           style="margin-bottom:1rem; max-height:8rem;"
           :src="noacc.rlogo.url">
        </img>
        <div v-if="noacc.msg.sh"
           style="width:100%;left:0;bottom:0;color:#ff8000">
           <div v-for="(line) in noacc.msg.txt">
              {{ line }}
           </div>
        </div>
     </b-col>
   </b-row>
   <b-row v-if="noacc.group.sh && noacc.group.en">
     <b-col style="text-align:center">
        <span style="color:#ff8000">
          You are a member of this room's group but group access is currently disabled.
        </span>
     </b-col>
   </b-row>
   <b-row v-if="noacc.website.sh && noacc.website.en">
     <b-col style="text-align: center;">
        <a :href="noacc.website.url" target="_blank"
          class="noa_link" style="text-decoration: none;">
          <span class="noa_mat">
             link
          </span>
          <span>
             Host's Website Link
          </span>
        </a>
     </b-col>
   </b-row>         
   <b-row v-if="noacc.cast.sh && noacc.cast.en">
     <b-col style="text-align:center">
        <span style="color:white">
           There is an active broadcast.
        </span>
        <router-link :to="{ name: 'cast'}">
           Click To Watch
        </router-link>
     </b-col>
   </b-row>
   <b-row class="mt-3" v-if="noacc.meeting.sh && noacc.meeting.en">
     <b-col sm="12">
        <span style="color:white">
           You were invited to a meeting starting
        </span>
        <span style="color:#ff8000">
           {{ noacc.meeting.atStr }}
        </span>
     </b-col>
     <b-col sm="12" v-if="!noacc.meeting.in">
        <span style="color:#ff8000">
          You cannot enter. The host may have locked the room.
        </span>
     </b-col>
     <b-col sm="12" v-if="noacc.meeting.in">
        <span style="color:white">
          The meeting will start
        </span>
        <span style="color:#ff8000">
          {{ noacc.meeting.in }}.
        </span>
     </b-col>
   </b-row>

   <b-row v-if="noacc.contact.sh && noacc.contact.en">
     <b-col>
        <b-row>
          <b-col>
            <span style="color:white">
              Send message
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
              <auto-text-area size="sm"
                style="width:100%"
                v-model.trim="contact.msg"
                :disabled="contact.sent"
                maxlength="250"
                placeholder="Leave a message">
              </auto-text-area>
              <span v-if="contact.sent"
                class="contact_sent">
                Message Sent
              </span>
          </b-col>
          <b-col v-if="!contact.sent">
              <b-button size="sm"
                :disabled="!contact.msg"
                @click="contact_send_msg"
                variant="primary">
                Send
              </b-button>
          </b-col>
        </b-row>
     </b-col>
   </b-row>
   <b-row v-if="noacc.vmail.sh && noacc.vmail.en">
     <b-col>
        <b-row>
          <b-col>
            <span style="color:white">
              Or you can record a short voicemail
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
             <b-button size="sm"
               v-if="contact.vmail_state =='ready'"
               @click="contact_voicemail_done()"
               variant="primary">
               Send
             </b-button>
             <b-button size="sm"
               v-if="contact.vmail_state =='ready'"
               @click="contact_voicemail"
               variant="primary">
               Redo
             </b-button>
             <b-button size="sm"
               v-if="contact.vmail_state =='ready'"
               @click="contact_voicemail_done(true)"
               variant="outline-danger">
               Cancel
             </b-button>
             <b-button size="sm"
               v-if="contact.vmail_state == 'rec'"
               @click="contact_voicemail"
               variant="primary">
               Record
             </b-button>
             <b-button size="sm"
               v-if="contact.vmail_state == 'starting'"
               variant="outline-secondary">
               Starting...
             </b-button>
             <b-button size="sm"
               v-if="contact.vmail_state == 'recing'"
               @click="contact_voicemail_stop"
               variant="danger">
               Stop
             </b-button>
             <b-button size="sm"
               v-if="contact.vmail_state == 'uping'"
               variant="outline-secondary">
               Uploading...
             </b-button>
          </b-col>
          <b-col sm="3"
             v-if="contact.vmail_state == 'recing'"
             style="color:white;font-size:0.8rem;">
             Elapsed {{ contact.vmail_elapsed.toFixed(1) }}
          </b-col>
          <b-col sm="8"
             style="position:relative;"
             v-if="(contact.vmail_state == 'rec' || contact.vmail_state == 'ready') && app.audio_sources"
          >
            <b-form-select v-model="app.selected_audio_source[app.sel_audio_idx]"
              style="padding:0"
              :options="app.audio_sources" size="sm"
              @change="onAudioSourceChange()">
            </b-form-select>
          </b-col>
          <b-col sm="12" style="text-align:center;"
             v-if="contact.vmail_state == 'ready'">
             <audio controls :src="contact.vmail_src"
               style="max-height:2rem;max-width:90%;"
               > </audio>
          </b-col>
          <b-col sm="12" v-if="contact.vmail_error"
             style="padding-left:3rem;color:red;font-size:0.8rem;font-weight:bold;">
             {{ contact.vmail_error }}
          </b-col>
        </b-row>
     </b-col>
   </b-row>
   <b-row v-if="contact.vmail_state == 'done_new'">
     <b-col>
       <span style="color:white">
          You have left a voicemail.
       </span>
     </b-col>
   </b-row>
   <b-row v-if="contact.vmail_state == 'done_exists'">
     <b-col>
       <span style="color:white">
          You have already left a voicemail. Another cannot be recorded at this time.
       </span>
     </b-col>
   </b-row>

   <div v-if="prompt.show" class="noa_prompt">
          <b-row>
            <b-col class="prompt_head">
              <span class="prompt_head_txt">
                {{prompt.msg}}
              </span>
            </b-col>
          </b-row>
          <b-row v-if="prompt.show_notify">
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="state_step('main-notewait')">
                Notify & Wait
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="prompt.show_meetnotify">
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="state_step('meet-notewait')">
                Notify & Wait
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="prompt.show_wait">
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="state_step('main-wait')">
                Continue Waiting
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="prompt.show_meetwait">
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="state_step('meet-wait')">
                Wait for Meeting
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="prompt.show_leavemsg">
            <b-col>
              <b-button size="sm" variant="outline-danger"
                class="prompt_btn"
                @click="state_step('leavemsg')">
                Leave a Message
              </b-button>
            </b-col>
          </b-row>
   </div>

  </div>
</div>
</template>

<script>

import EncodeWorker from "worker-loader!../encode.worker.js"
import AutoTextArea from "../components/AutoTextArea";

export default {
  name: "NoAccess",
  props: ["app","tgt"],
  components: {
    AutoTextArea,
  },
  watch: {
  },
  data() {
    return  {
      contact: {
        msg: "",
        sent: false,
        vmail_error: "",
        vmail_elapsed: 0,
        vmail_state: "rec",
      },
      prompt: {
        msg: "",
        show: false,
        show_notify: false,
        show_meetnotify: false,
        show_wait: false,
        show_meetwait: false,
        show_leavemsg: false,
      },
      noacc: {
        state: "off",
        show_back: false,
        rlogo: {
          sh: false,
          en: false,
          url: "",
        },
        msg: {
          sh: false,
          txt: [],
        },
        website: {
          sh: false,
          en: false,
          url: "",
        },
        cast: {
          sh: false,
          en: false,
        },
        contact: {
          sh: false,
          en: false,
        },
        vmail: {
          sh: false,
          en: false,
        },
        meeting: {
          sh: false,
          en: false,
          at: 0,
          atStr: "",
          in: "",
        },
        group: {
          en: false,
          sh: false,
        },
      },
    };
  },
  computed: {
  },
  mounted() {
    let vue = this;
    if (vue.app.leaveMsgText) {
      vue.contact.msg = vue.app.leaveMsgText;
    }
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    is_showing: function() {
      return this.noacc.state != "off";
    },
    close: function() {
      let vue = this;
      vue.stop_meeting_countdown();
      clearTimeout(vue.prompt.tid);
    },
    update_hist: function(doadd) {
      let vue = this;
      let noah = getLocal("noah",true) || {hist:[]};
      let room = vx.room.name;
      let nows = Math.trunc(Date.now()/1000);
      let found = false;
      /* Purge expired records. See if current room
       *   exists and is unexpired  */
      noah.hist = noah.hist.filter(function(h) {
        if (nows > (h.at + 600)) { return false; }
        if (h.r == room) {
          found = true;
        }
        return true;
      });
      if (doadd && !found) {
        noah.hist.push({r:room,at:nows});
      }
      setLocal("noah",JSON.stringify(noah));
      //console.log("noaccess noah",JSON.stringify(noah));
      return found;
    },
    trigger_noaccess: function(opt) {
      let vue = this;
      if (vx && vx.debug) { console.log("noaccess trigger",JSON.stringify(opt)); }
      if (opt.reset) {
         vue.state_step("off");
         return;
      }

      /* Go to initial state if transitioning from 'off'.
         Otherwise do nothing. */
      if (vue.noacc.state != "off") { return; }
      if (!opt.txt && !opt.noa_msg && !opt.rlogo && !opt.can_contact && !opt.can_vmail) {
        vue.noacc.show_back = true;
        /* Invalid room? */
        vue.state_step("error");
        return;
      }

      if (opt.error == "expired") {
         /* Room is no longer active */
         vue.state_step("expired");
         return;
      }
      if (window.is_my_room(vx)) {
         /* Room disabled or deleted? */
         vue.state_step("error");
         return;
      }

      /* Common fields */
      if (opt.noa_msg) {
         vue.noacc.msg.txt = opt.noa_msg.split(/\n\r?/);
      } else if (opt.txt) {
         vue.noacc.msg.txt = [ txt ];
      } else {
         vue.noacc.msg.txt = ["You cannot access this room"];
      }
      if (opt.rlogo && opt.rlogo != "-") {
        vue.noacc.rlogo.en = true;
        vue.noacc.rlogo.url = opt.rlogo;
      }
      if (opt.url) {
        vue.noacc.website.en = true;
        vue.noacc.website.url = opt.url;
      }
      if (opt.has_cast) {
        vue.noacc.cast.en = true;
      }
      if (opt.can_contact) {
        vue.noacc.contact.en = true;
      }
      if (opt.can_vmail) {
        vue.noacc.vmail.en = true;
      }
      vue.app.hidePanel();
      if (opt.init_state) {
        vue.state_step(opt.init_state);
        return;
      }

      /* Determine initial state */
      let nows = Math.trunc(Date.now()/1000);
      if (opt.restart) {
         vue.noacc.msg.txt = ["Page will be reloaded..."];
         vue.state_step("restart");
      } else if (opt.check_meet) {
          /* Check for meetings and do meeting flow if any exit */
          let min_start_ep;
          window.wss_send_cb(window.vx, "get_meetings", {
             tgt_em:"self",for_tm:"all"
          }, function(msg) {
              //console.log("noaccess meeting",msg);
              if (!msg || !msg.data) {
                 vue.state_step("main");
                 return;
              }
              for (let i=0; i<msg.data.length; i++) {
                 let m = msg.data[i];
                 if (m.start_ep < nows && m.end_ep >= nows) {
                  /* Scheduled for a meeting, host may have locked */
                  vue.noacc.meeting.en = true
                  vue.noacc.meeting.at = new Date(m.start_ep * 1000);
                  vue.noacc.meeting.atStr = vue.noacc.meeting.at.toLocaleDateString("en-US",{ weekday: 'short', hour: "2-digit", minute: "2-digit"});
                  vue.noacc.meeting.in = "";
                  break;
                } else if (m.start_ep == 2111222333) {
                  /* In group but group access disabled. */
                  vue.noacc.group.en = true;
                } else if (m.start_ep >= nows &&
                           (!min_start_ep || m.start_ep < min_start_ep)) {
                  /* Future meeting. Count down. 'restart' once time is up */
                  vue.noacc.meeting.en = true
                  vue.noacc.meeting.at = new Date(m.start_ep * 1000);
                  vue.noacc.meeting.atStr = vue.noacc.meeting.at.toLocaleDateString("en-US",{ weekday: 'short', hour: "2-digit", minute: "2-digit"});
                  vue.noacc.meeting.in = "--";
                  min_start_ep = m.start_ep;
                }
              }
              if (vue.noacc.meeting.en) {
                 vue.state_step("meet");
              } else {
                 vue.state_step("main");
              }
          });
      } else {
        vue.state_step("main");
      }
    },
    start_meeting_countdown: function() {
       let vue = this;
       clearTimeout(vue.noacc.tid);
       vue.noacc.tid = window.setInterval(function() {
          let delta = ((vue.noacc.meeting.at - Date.now())/1000)+5;
          if (delta < 0) {
             vue.stop_meeting_countdown();
             vue.$emit("restart",true);
             return;
          }
          if (delta <= 2) {
             vue.noacc.meeting.in = "in just a second";
          } else if (delta < 120) {
             delta = Math.ceil(delta);
             vue.noacc.meeting.in = "in "+delta+" sec";
          } else if (delta < 7200) {
             delta = Math.ceil(delta/60);
             vue.noacc.meeting.in = "in "+delta+" min";
          } else {
             delta = Math.ceil(delta/3600);
             vue.noacc.meeting.in = "in "+delta+" hours";
          }
       },1000);
    },
    stop_meeting_countdown: function() {
       let vue = this;
       clearTimeout(vue.noacc.tid);
       vue.noacc.meeting.in = "";
       vue.noacc.meeting.at = 0;
       vue.noacc.meeting.atStr = "";
    },
    state_step: function(state) {
      let vue = this;
      if (vx && vx.debug) { console.log("noaccess state",state); }
      switch(state) {
      case "off":
        vue.noacc.show_back = false;
        vue.noacc.rlogo.sh = false;
        vue.noacc.rlogo.en = false;
        vue.noacc.msg.sh = false;
        vue.noacc.website.sh = false;
        vue.noacc.website.en = false;
        vue.noacc.cast.sh = false;
        vue.noacc.cast.en = false;
        vue.noacc.contact.sh = false;
        vue.noacc.contact.en = false;
        vue.noacc.vmail.sh = false;
        vue.noacc.vmail.en = false;
        vue.noacc.meeting.sh = false;
        vue.noacc.meeting.at = 0;
        vue.noacc.meeting.atStr = "";
        vue.noacc.meeting.in = "";
        vue.noacc.group.sh = false;
        vue.noacc.group.en = false;
        vue.stop_meeting_countdown();
        vue.noacc.state = state;
        vue.prompt.msg = "";
        vue.prompt.show = false;
        vue.prompt.show_notify = false;
        vue.prompt.show_meetnotify = false;
        vue.prompt.show_wait = false;
        vue.prompt.show_meetwait = false;
        break;
      case "main":
        vue.noacc.rlogo.sh = true;
        vue.noacc.msg.sh = true;
        vue.noacc.website.sh = true;
        vue.noacc.cast.sh = true;
        vue.noacc.group.sh = true;
        vue.noacc.state = state;

        if (vue.noacc.contact.en || vue.noacc.vmail.en) {
          vue.prompt.msg = "Would you like to notify the owner and wait or leave a message?";
          vue.prompt.show_leavemsg = true;
        } else {
          vue.prompt.msg = "Would you like to notify the owner and wait?";
          vue.prompt.show_leavemsg = false;
        }
        vue.prompt.show = true;
        vue.prompt.show_notify = true;
        vue.prompt.show_wait = false;
        break;
      case "main-notewait":
        vue.prompt.show = false;
        vue.notify(15);
        vue.noacc.state = state;
        break;
      case "main-wait":
        vue.prompt.show = false;
        vue.notify(15);
        vue.noacc.state = state;
        break;
      case "meet":
        vue.noacc.rlogo.sh = true;
        vue.noacc.website.sh = true;
        vue.noacc.cast.sh = true;
        vue.noacc.group.sh = true;
        vue.noacc.meeting.sh = true;
        vue.noacc.state = state;

        if (vue.noacc.contact.en || vue.noacc.vmail.en) {
           if(vue.noacc.meeting.in) {
              vue.prompt.msg = "Would you like to notify the owner you are here or just wait for the meeting to start?";
              vue.prompt.show_meetwait = true;
              vue.start_meeting_countdown();
           } else {
              vue.prompt.msg = "Would you like to notify the owner you are here or leave a message?";
           }
           vue.prompt.show_leavemsg = true;
        } else {
           if(vue.noacc.meeting.in) {
              vue.prompt.msg = "Would you like to notify the owner you are here or just wait for the meeting to start?";
              vue.prompt.show_meetwait = true;
              vue.start_meeting_countdown();
           } else {
              vue.prompt.msg = "Would you like to notify the owner you are here?";
           }
           vue.prompt.show_leavemsg = false;
        }
        vue.prompt.show = true;
        vue.prompt.show_meetnotify = true;
        break;
      case "meet-notewait":
        /* Meeting refreshes the page once started. Notify and skip timer. */
        vue.prompt.show = false;
        vue.notify(0);
        vue.noacc.state = state;
        break;
      case "meet-wait":
        /* Meeting refreshes the page once started. No action needed. */
        vue.prompt.show = false;
        vue.noacc.state = state;
        break;
      case "waited":
        if (vue.noacc.state == "meet-wait" ||
            vue.noacc.state == "meet-notewait") {
            /* Timer currently skipped */
        } else {
          /* main-wait, main-notewait */
          vue.prompt.msg = "";
          if (vue.noacc.state == "main-notewait") {
             vue.prompt.msg = "We contacted the owner. ";
          }
          if (vue.noacc.contact.en || vue.noacc.vmail.en) {
             vue.prompt.msg += "Would you like to continue waiting or leave a message?";
          } else {
             vue.prompt.msg += "Would you like to continue waiting?";
          }
          vue.prompt.show = true;
          vue.prompt.show_notify = false;
          vue.prompt.show_wait = true;
        }
        break;
      case "notify-failed":
        if (vue.noacc.state == "meet-wait" ||
            vue.noacc.state == "meet-notewait") {
          if (vue.noacc.contact.en || vue.noacc.vmail.en) {
            if(vue.noacc.meeting.in) {
               vue.prompt.msg = "We were unable to contact the owner. Would you like to wait for the meeting to start or leave a message?";
            } else {
               vue.prompt.msg = "We were unable to contact the owner. Would you like to leave a message?";
            }
          } else {
             vue.prompt.msg = "We were unable to contact the owner.";
             vue.prompt.show_meetwait = false;
          }
          vue.prompt.show_meetnotify = false;
          vue.prompt.show = true;
        } else {
          // main-notewait
          if (vue.noacc.contact.en || vue.noacc.vmail.en) {
            vue.prompt.msg = "No one is available right now. Would you like to leave a message or continue waiting?";
          } else {
            vue.prompt.msg = "We were unable to contact the owner. Would you like to continue waiting.";
          }
          vue.prompt.show_notify = false;
          vue.prompt.show_wait = true;
          vue.prompt.show = true;
        }
        break;
      case "leavemsg":
        /* rlogo, msg, etc. set to true here in case state set
         *   directly to leavemsg (skipping main/meeting) when
         *   from lobby's leavemsg */
        vue.noacc.rlogo.sh = true;
        vue.noacc.msg.sh = true;
        vue.noacc.website.sh = true;
        vue.noacc.cast.sh = true;
        vue.noacc.contact.sh = true;
        vue.noacc.vmail.sh = true;
        vue.noacc.state = state;
        vue.prompt.show = false;
        vue.app.mydevice.stop_capture();
        break;
      case "restart":
        vue.noacc.rlogo.sh = true;
        vue.noacc.msg.sh = true;
        vue.noacc.website.sh = true;
        window.setTimeout(function() {
           vue.$emit("restart",true);
        }, (1000*opt.restart));
        vue.noacc.state = state;
        break;
      case "expired":
        vue.noacc.msg.txt = ["Use of this room has expired."];
        vue.noacc.msg.sh = true;
        vue.noacc.state = state;
        break;
      case "error":
        vue.noacc.msg.txt = ["This room is invalid, disabled, or an error occurred."];
        vue.noacc.msg.sh = true;
        vue.noacc.state = state;
        break;
      }
    },
    notify: function(waitsec) {
      let vue = this;
      let sms_allowed = !vue.update_hist(true);
      clearTimeout(vue.prompt_tid);
      wss_send_cb(vx, "arrival", {
        state: {
          sms_allowed: sms_allowed,
        },
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.ok) {
          return;
        }
        if (msg.data.sent_cnt) {
           if (waitsec) {
               vue.prompt_tid = setTimeout(function() {
                  vue.state_step("waited");
               }, 1000*waitsec);
           }
        } else {
           vue.prompt_tid = setTimeout(function() {
             vue.state_step("notify-failed");
           }, 15000);
        }
      });
    },
    contact_send_msg: function() {
      let vue = this;
      let tgt = "room";
      if (vue.tgt && vue.tgt.length) {
        tgt = ""+vue.tgt;
      }
      window.wss_send(window.vx, "contact", {
        msg: ""+vue.contact.msg,
        tgt: tgt,
      });
      vue.contact.sent = true;
    },
    contact_voicemail_done: function(cancel) {
      let vue = this;
      window.URL.revokeObjectURL(vue.contact.vmail_src);
      if (!cancel) {
        vue.noacc.vmail.en = false;
        vue.contact.vmail_state = "done_new";
      } else {
        window.wss_send_cb(window.vx, "voicemail_up", {
          vm:{
            id: vue.contact.vm_id,
            rem: true,
          },
        }, function(msg) {
          vue.contact.vmail_state = 'rec';
          vue.contact.vmail_elapsed = 0;
          delete vue.contact.vm_id;
          delete vue.contact.vm_url;
        });
      }
    },
    contact_voicemail_stop: function() {
      let vue = this;
      let media = vue.app.mydevice.get_media();
      vue.contact.vmail_state = 'uping';
      const blob = new Blob([vue.contact.put_data], { type: "audio/aac" });
      vue.contact.vmail_src = window.URL.createObjectURL(blob);
      issue_http({
        url: vue.contact.vm_url,
        type: "PUT",
        contentType: "audio/aac",
        nocred:true,
        data: vue.contact.put_data,
        done: function(status, data) {
          if (status < 300) {
            vue.contact.vmail_state = 'ready';
          } else {
            vue.contact.vmail_error = "Unable to upload recording.";
          }
        }
      });
      vue.contact.put_data = null;
      media.stopCapture();
      vue.contact.encodeWorker.terminate();
      delete vue.contact.encodeWorker;
    },
    contact_voicemail_geturl: function(cb) {
       let vue = this;
       if (vue.contact.vm_url) {
         cb();
         return;
       }

       window.wss_send_cb(window.vx, "voicemail", {
         cfg: {
           "content-type": "audio/aac",
         }
       }, function(msg) {
         if (!msg || !msg.data || !msg.data.url) {
           if (msg.data.exists) {
              vue.contact.vmail_state = 'done_exists';
              vue.noacc.vmail.en = false;
           } else {
              vue.contact.vmail_state = 'rec';
              vue.contact.vmail_error = "Voicemail currently unavailable.";
           }
           return;
         }
         vue.contact.vm_id = msg.data.id;
         vue.contact.vm_url = msg.data.url;
         cb();
       });
    },
    contact_voicemail: function() {
      let vue = this;
      let media = vue.app.mydevice.get_media();
      let cnt = 0;
      vue.contact.vmail_error = "";
      vue.contact.vmail_state = 'starting';
      /* For some reason iOS15 fails in following sequence
         the very first time only:
           room1 => capture => unmute speaker =>
              room2 no-access => record voicemail
      */
      vue.app.mydevice.stop_capture();
      vue.app.refreshAVSources({
        notify: function() {},
        cb: function() {
          let opt = {};
          opt.gid = vue.app.selected_audio_source[0];
          if (!opt.gid) {
            vue.contact.vmail_state = 'rec';
            vue.contact.vmail_error = "No mics found.";
            return;
          }
          vue.contact_voicemail_geturl(function() {
            vue.contact.put_data = null;
            vue.contact.vmail_elapsed = 0;
            vue.contact.encoder_state = "new";
            vue.contact.encodeWorker = new EncodeWorker();
            opt.cb_pushraw = function(fct, sr, ch, lbuf, rbuf) {
               if (vue.contact.vmail_state != 'recing') { return; }
               let arr = window.flt2wav(sr, 1, lbuf);
               vue.contact.encodeWorker.postMessage({
                 type:"araw",
                 fct:1,
                 mnum: 1,
                 arr:arr
               },
               [ arr ] );
            }
            vue.contact.encodeWorker.onmessage = function(e) {
              const msg = e.data;
              if (msg.type == "loaded") {
                vue.contact.encodeWorker.postMessage({
                  type: "ainit",
                  cfg: {
                    sr: 44100,
                    br: 64000,
                  },
                  debug: true,
                });
                return;
              } else if (msg.type == "ready") {
                vue.contact.encodeWorker.postMessage({type: "arun"});
                media.enableCaptureOutput({start_ep:Date.now()});
                vue.contact.encoder_state = "ready";
                return;
              } else if (msg.type != "frm") {
                return;
              }
              if (vue.contact.vmail_state != 'recing') {
                return;
              }
              /* Data is padded with 6 bytes */
              let buf = new Uint8Array(msg.buf).subarray(6);
                if (buf && buf.byteLength) {
                  vue.contact.vmail_elapsed += 1024/44100;
                  if (!vue.contact.put_data) {
                    vue.contact.put_data = new Uint8Array(buf);
                  } else {
                    let prv_len = vue.contact.put_data.length;
                    let prv_data = vue.contact.put_data;
                    vue.contact.put_data =
                        new Uint8Array(prv_len + buf.byteLength);
                    vue.contact.put_data.set(prv_data,0);
                    vue.contact.put_data.set(new Uint8Array(buf),prv_len);
                  }
                }
              if (vue.contact.vmail_elapsed > 30) {
                vue.contact_voicemail_stop();
              }
            }
            media.streamAudio(opt, function(ctx,err) {
              //console.log(ctx,err);
              if (!ctx) {
                vue.contact.vmail_error = "Unable to start recording";
                return;
              }
              vue.contact.vmail_state = 'recing';
              if (vue.contact.encoder_state == "ready") {
                /* Enable here in case encoder was ready before the stream.
                 * If so, it's call to enable would not have had any
                 * effect. */
                media.enableCaptureOutput({start_ep:Date.now()});
              }
            }); //streamAudio
          }); // voicemail
        }
      }); // refresh A/V
    },
  },
}
</script>

<style lang="scss" scoped>

.noa_prompt {
  max-width: 22rem;
  margin: 1rem auto;
  background-color: white;
  padding: 1rem;
  border: 1px solid black;
  border-radius: 0.5rem;
}

.noa_link {
  padding: 0.1rem 0.5rem;
}
.noa_link:hover {
  background-color: rgba(0,0,0,0.2);
  border-radius: 10px;
}
.noa_mat {
  font-family:'Material Icons';
  font-size: 1.2rem;
  color:white;
  vertical-align: middle;
}

#room_alerts {
  position: absolute;
  width: 100%;
  top:0;
  left:0;
  right:0;
  z-index:1;
  padding: 15px;
}

.alerts_card {
  margin: 0rem auto;
  max-width: 40rem;
  border-radius: 5px;
  padding: 0.25rem;
  background-color: #303030;
}

.contact_sent {
  position: absolute;
  color:rgb(255, 128, 0);
  font-size: 0.8rem;
  font-weight: bold;
  left: 1rem;
  bottom: -1rem;
}
</style>